<script>
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'
import { get } from 'lodash'
import { Place } from '@/api'

export default {
  extends: BaseWidgetForm,
  data() {
    return {
      arrayFields: ['items']
    }
  },
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'Ogólne',
          fields: [
            ...this.getCommonFields(),
            new fields.Switch({
              label: 'Ukryty tytuł',
              modelPath: [this, 'form', 'is_title_hidden']
            }),
            new fields.Input({
              label: 'Tytuł',
              modelPath: [this, 'form', 'title'],
              multilingual: true,
              required: true
            }),
            new fields.Header({
              text: 'Festiwale'
            }),
            new fields.Formset({
              modelPath: [this, 'form', 'items'],
              items: this.form.items.map((item, i) => ({
                headerLabel: get(item, ['name_pl']),
                fields: [
                  new fields.Input({
                    label: 'Nazwa',
                    required: true,
                    modelPath: [this, 'form', 'items', i, 'name'],
                    multilingual: true
                  }),
                  new fields.Input({
                    label: 'Zakres dat',
                    modelPath: [this, 'form', 'items', i, 'dates']
                  }),
                  new fields.Input({
                    label: 'Tekst w tle',
                    modelPath: [this, 'form', 'items', i, 'bg_text'],
                    multilingual: true
                  }),
                  new fields.Link({
                    label: 'Odnośnik',
                    modelPath: [this, 'form', 'items', i, 'link'],
                    hideLinkLabel: true
                  }),
                  new fields.ForeignKey({
                    service: Place,
                    label: 'Miejsce',
                    modelPath: [this, 'form', 'items', i, 'place'],
                    labelField: 'name_pl'
                  })
                ]
              }))
            })
          ]
        }
      ]
    }
  }
}
</script>
